module.exports = {"path":["Dashboard","IndividualTour","Add Records"],"submit":"Submit","update":"Update","reset":"Reset","group":"Add Group","groupEdit":"Edit Group","groupError":"Network Error, can not set up group for this transaction. Try again later."}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/individualtour/create/index.json
// module id = nET+
// module chunks = 58